<template lang="html">
  <div class="mfa-code-prompt is-flex">
    <div class="centerit">
      <div class="centerit-body">
        <div class="mfa-prompt-box box is-padded-large">
          <div class="content">
            <div class="is-padded-medium">
              <h2 class="has-text-centered is-size-4">
                {{ title }}
              </h2>
              <cw-mfa-verification
                v-model="code"
                :title="title"
                :message="message"
                :phoneNumber="phoneNumber"
                :errorMessage="errorMessage"
                :showResend="!!onResend"
                submitText="Verify"
                cancelText="Cancel"
                @verify="handleVerify"
                @resend="handleResend"
                @cancel="handleCancel"
              />
            </div>
          </div>
          <div class="status-icon is-large is-primary">
            <span class="icon">
              <i class="la la-lock"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MFAVerification from '@/components/cwkit/MFAVerification';

export default {
  name: 'mfa-code-prompt',
  components: {
    'cw-mfa-verification': MFAVerification,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'Two-Factor Authentication',
    },
    message: {
      type: String,
      required: false,
      default: "We've sent a 6-digit verification code to",
    },
    phoneNumber: {
      type: String,
      required: false,
      default: null,
    },
    onVerify: {
      type: Function,
      required: true,
    },
    onCancel: {
      type: Function,
      required: false,
      default: null,
    },
    onResend: {
      type: Function,
      required: false,
      default: null,
    },
    errorMessage: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      code: '',
    };
  },
  methods: {
    handleVerify(code) {
      if (code && code.length === 6 && this.onVerify) {
        this.onVerify(code);
      }
    },
    handleCancel() {
      if (this.onCancel) {
        this.onCancel();
      }
      this.$modal.hide('mfa-code-prompt');
    },
    async handleResend() {
      if (this.onResend) {
        this.code = ''; // Clear the input
        await this.onResend();
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.mfa-code-prompt {
  flex-direction: column;
  margin: auto;
  padding: 20px;
  max-width: 30em;
  overflow: visible;

  @media screen and (max-width 765px - 1px) and (max-height 765px) {
    height: 100vh;
  }

  .centerit {
    flex-grow: 1;

    .centerit-body {
      max-width: 400pt;
    }
  }

  .mfa-prompt-box {
    padding-bottom: 1rem;
    margin-bottom: 4rem;
    position: relative;
    box-shadow: 0 10px 300.0px rgba(#100, 0.5);

    .status-icon {
      position: absolute;
      bottom: -2.25rem;
      left: calc(50% - 2.25rem - 2px);
      border-width: 4px;
      border-color: white;
    }
  }
}
</style>
